<div class="flex min-w-0 flex-auto flex-col @container">
    <!-- Header -->
    <div
        class="bg-card flex flex-0 flex-col border-b p-6 dark:bg-transparent sm:flex-row sm:items-center sm:justify-between sm:px-8 sm:py-8"
    >
        <div class="min-w-0 flex-1">
            <!-- Title -->
            <app-title-with-icon
                [title]="'Overview'"
                [icon]="'mat_symbols_outlined:in_home_mode'"
                [showIcon]="true"
            ></app-title-with-icon>
        </div>
    </div>

    @if (showDistributorClientCard) {
        <div class="flex p-6 justify-center">
            <div class="m-6 w-full md:m-0 md:w-1/2 md:max-w-screen-md shadow-lg rounded-2xl border border-gray-200">
                <app-distributor-company-card></app-distributor-company-card>
            </div>
        </div>
    } @else {

    <!-- Main -->
    <div class="flex flex-col gap-6 p-6 sm:p-10">
        <!-- <img src="images/mocks/vision_general.png"/> -->

        <!-- Status display title -->
        @if(this.companyStatus().hasCompany){
            <div class="flex w-full items-center justify-between">
                <div>
                    <div class="text-3xl font-semibold leading-8 tracking-tight">
                        {{ 'Status display' | transloco }}
                    </div>
                </div>
            </div>
        }

        <!-- Device KPI container -->
        @if (deviceKpis.length > 0) {
            <div class="grid w-full grid-cols-1 @sm:grid-cols-3 gap-8">
                <!-- KPI widget -->
                @for (kpi of deviceKpis; track kpi.title) {
                    <a class="manusa-card-actionable"
                    (click)="onKpiClick(kpi.title)"
                    >
                        <app-kpi-widget title="{{ kpi.title | transloco }}" [colors]="kpi.colors" [icon]="kpi.icon" [value]="kpi.value" [total]="kpi.total"></app-kpi-widget>
                    </a>
                }
            </div>
        } @else {
            @if(!this.companyStatus().isRestricted) {
                <p>{{ 'There are no devices yet in this company' | transloco }}.</p>
            } @else if(!this.companyStatus().hasCompany) {
                <div class="flex justify-center">
                    <div class="m-6 w-full md:m-0 md:w-1/2 md:max-w-screen-md shadow-lg rounded-2xl border border-gray-200 ">
                        <app-link-company-card></app-link-company-card>
                    </div>
                </div>
            } @else {
                <p>{{ 'You don’t have permission to view these metrics' | transloco }}.</p>
            }
        }

        @if (this.companyStatus().hasCompany) {
        <!-- Associations with devices title -->
        <div class="flex w-full items-center justify-between mt-5">
            <div>
                <div class="text-3xl font-semibold leading-8 tracking-tight">
                    {{ 'Custom configurations' | transloco }}
                </div>
            </div>
        </div>

        <!-- Keys and scheduled actions KPIs container -->
        <div class="grid w-full grid-cols-1 @sm:grid-cols-2 gap-8">

            <!-- Keys KPI widget -->
            <a class="manusa-card-actionable"
               [routerLink]="['/keys']"
            >
                <div class="flex justify-between items-center py-3 px-5">
                    <!-- Split data between 2 columns -->
                    <div class="flex flex-1 flex-col justify-between h-full mr-4">
                        <!-- Split first col into 2 rows, first one has title -->
                        <div class="flex items-center mb-2">
                            <h3 class="leading-5 text-gray-500">{{ 'Active keys' | transloco }}</h3>
                        </div>

                        <!-- Second line has total -->
                        <p class="text-8xl font-bold text-gray-700 ml-1">
                            {{ totalActiveKeys }}
                        </p>
                    </div>

                    <!-- Second column has the indicators-->
                    <div class="flex flex-1 flex-col gap-3">
                        <div class="flex flex-col">
                            <div class="flex items-center">
                                <div
                                    class="flex h-10 w-10 min-w-10 items-center justify-center rounded bg-blue-100 text-blue-800 dark:bg-blue-600 dark:text-blue-50"
                                >
                                    <mat-icon
                                        class="text-current"
                                        [svgIcon]="'mat_solid:smartphone'"
                                    ></mat-icon>
                                </div>
                                <div class="ml-4 flex-auto leading-none">
                                    <div class="text-secondary text-sm font-medium">
                                        {{ 'Selector type' | transloco }}
                                    </div>
                                    <!-- custom color, see .scss file -->
                                    <mat-progress-bar
                                        class="mt-2 rounded-full selector-key-color"
                                        [mode]="'determinate'"
                                        [value]="subtotalSelectorKeys / totalActiveKeys * 100"
                                    ></mat-progress-bar>
                                </div>
                                <div class="ml-4 leading-none">
                                    <div class="mt-2 rounded-full text-gray-700 text-xl text-nowrap font-medium">
                                        {{ subtotalSelectorKeys }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="flex flex-col">
                            <div class="flex items-center">
                                <div
                                    class="flex h-10 w-10 min-w-10 items-center justify-center rounded bg-yellow-200 text-yellow-500 dark:bg-yellow-600 dark:text-yellow-50"
                                >
                                    <mat-icon
                                        class="text-current"
                                        [svgIcon]="'mat_solid:vpn_key'"
                                    ></mat-icon>
                                </div>
                                <div class="ml-4 flex-auto leading-none">
                                    <div class="text-secondary text-sm font-medium">
                                        {{ 'Virtual key' | transloco }}
                                    </div>
                                    <!-- custom color, see .scss file -->
                                    <mat-progress-bar
                                        class="mt-2 rounded-full virtual-key-color"
                                        [mode]="'determinate'"
                                        [value]="subtotalVirtualKeys / totalActiveKeys * 100"
                                    ></mat-progress-bar>
                                </div>
                                <div class="ml-4 leading-none">
                                    <div class="mt-2 rounded-full text-gray-700 text-xl text-nowrap font-medium">
                                        {{ subtotalVirtualKeys }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </a>

            <!-- Scheduled actions KPI widget -->
            <a class="manusa-card-actionable"
               [routerLink]="['/scheduled-actions']"
            >
                <div class="flex justify-between items-center py-3 px-5">
                    <!-- Split data between 2 columns -->
                    <div class="flex flex-1 flex-col justify-between h-full mr-4">
                        <!-- Split first col into 2 rows, first one has title -->
                        <div class="flex items-center mb-2">
                            <h3 class="leading-5 text-gray-500">{{ 'Scheduled actions' | transloco }}</h3>
                        </div>

                        <!-- Second line has total -->
                        <p class="text-8xl font-bold text-gray-700 ml-1">
                            {{ totalScheduledActions }}
                        </p>
                    </div>

                    <!-- Second column has the indicators-->
                    <div class="flex flex-1 flex-col gap-3">
                        <div class="flex flex-col">
                            <div class="flex items-center">
                                <div
                                    class="flex h-10 w-10 min-w-10 items-center justify-center rounded bg-green-200 text-green-600 dark:bg-green-600 dark:text-green-50"
                                >
                                    <mat-icon
                                        class="text-current"
                                        [svgIcon]="'mat_solid:update'"
                                    ></mat-icon>
                                </div>
                                <div class="ml-4 flex-auto leading-none">
                                    <div class="text-secondary text-sm font-medium">
                                        {{ 'Scheduled devices' | transloco }}
                                    </div>
                                    <!-- custom color, see .scss file -->
                                    <mat-progress-bar
                                    class="mt-2 rounded-full scheduled-action"
                                    [mode]="'determinate'"
                                    [value]="subtotalScheduledDevicesPercentage"
                                ></mat-progress-bar>
                                </div>
                                <div class="ml-4 leading-none">
                                    <div
                                        class="mt-2 rounded-full text-gray-700 text-xl text-nowrap font-medium"
                                    >{{ subtotalScheduledDevices }} / {{ totalDevices }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="flex flex-col">
                            <div class="flex items-center">
                                <div
                                    class="flex h-10 w-10 min-w-10 items-center justify-center rounded bg-gray-200 text-gray-500 dark:bg-gray-600 dark:text-gray-50"
                                >
                                    <mat-icon
                                        class="text-current"
                                        [svgIcon]="'mat_solid:update_disabled'"
                                    ></mat-icon>
                                </div>
                                <div class="ml-4 flex-auto leading-none">
                                    <div class="text-secondary text-sm font-medium">
                                        {{ 'Non-scheduled devices' | transloco }}
                                    </div>
                                    <mat-progress-bar
                                    class="mt-2 rounded-full"
                                    [color]="'accent'"
                                    [mode]="'determinate'"
                                    [value]="subtotalNonScheduledDevicesPercentage"
                                ></mat-progress-bar>
                                </div>
                                <div class="ml-4 leading-none">
                                    <div
                                        class="mt-2 rounded-full text-gray-700 text-xl text-nowrap font-medium"
                                    >{{ subtotalNonScheduledDevices }} / {{ totalDevices }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </a>

        </div>

        <div *ngIf="!this.companyStatus().isRestricted">
            <!-- Errors and warnings title -->
            <div class="flex w-full items-center justify-between mt-5">
                <div>
                    <div class="text-3xl font-semibold leading-8 tracking-tight">
                        {{ 'Warnings and errors' | transloco }}
                    </div>
                </div>
            </div>
            <div class="relative">
                <app-company-devices-failures-widget
                    [companyId]="_workingCompany.id"
                    [loading]="loadingFailures"
                    (loadingChange)="onLoadingFailuresChange($event)">
                </app-company-devices-failures-widget>

                @if (loadingFailures) {
                    <div class="absolute inset-0 grid place-items-center bg-white/60 dark:bg-gray-900/60 rounded-md z-10">
                        <mat-spinner diameter="42"></mat-spinner>
                    </div>
                }
            </div>
        </div>
        }
        <!-- Device errors and warnings widget -->

        <!-- Warnings and errors full chart data -->
        <!-- TODO Re-enable if we can build a suitable dataset for this chart
        <div class="manusa-card">
            <div class="m-6 mb-0 flex items-start justify-between">
                <div
                    class="truncate text-lg font-medium leading-6 tracking-tight"
                >
                    {{ 'History of warnings and errors' | transloco }}
                </div>
                <div class="ml-2">
                    <button
                        class="bg-hover h-6 min-h-6 rounded-full px-2"
                        mat-button
                    >
                        <span class="text-secondary text-sm font-medium"
                        >2023</span
                        >
                    </button>
                    <button
                        class="bg-primary ml-2 bg-hover h-6 min-h-6 rounded-full px-2"
                        mat-button
                    >
                        <span class="text-on-primary text-sm font-medium"
                        >2024</span
                        >
                    </button>
                </div>
            </div>
            <div class="mx-6 mt-6 flex items-start">
                <div class="grid grid-cols-1 gap-8 sm:grid-cols-3 sm:gap-12">
                    <div class="flex flex-col">
                        <div class="flex items-center">
                            <mat-icon class="text-[13px] text-yellow-500">circle</mat-icon>
                            <div class="text-secondary font-medium leading-5">
                                Total warnings
                            </div>
                            <mat-icon
                                class="text-hint ml-1.5 icon-size-4"
                                [svgIcon]="'heroicons_mini:information-circle'"
                                [matTooltip]="
                                    'Score is calculated by using the historical ratio between Page Views and Visitors. Best score is 1000, worst score is 0.'
                                "
                            ></mat-icon>
                        </div>
                        <div class="mt-2 flex items-start">
                            <div
                                class="text-4xl font-bold leading-none tracking-tight"
                            >
                                {{ data.visitorsVsPageViews.overallScore }}
                            </div>
                            <div class="ml-2 flex items-center">
                                <mat-icon
                                    class="text-green-500 icon-size-5"
                                    [svgIcon]="
                                        'heroicons_solid:arrow-up-circle'
                                    "
                                ></mat-icon>
                                <div
                                    class="ml-1 text-md font-medium text-green-500"
                                >
                                    42.9%
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col">
                        <div class="flex items-center">
                            <mat-icon class="text-[13px] text-red-500">circle</mat-icon>
                            <div class="text-secondary font-medium leading-5">
                                Total errors
                            </div>
                            <mat-icon
                                class="text-hint ml-1.5 icon-size-4"
                                [svgIcon]="'heroicons_mini:information-circle'"
                                [matTooltip]="
                                    'Average Ratio is the average ratio between Page Views and Visitors'
                                "
                            ></mat-icon>
                        </div>
                        <div class="mt-2 flex items-start">
                            <div
                                class="text-4xl font-bold leading-none tracking-tight"
                            >
                                {{
                                    data.visitorsVsPageViews.averageRatio
                                        | number: '1.0-0'
                                }}
                            </div>
                            <div class="ml-2 flex items-center">
                                <mat-icon
                                    class="text-red-500 icon-size-5"
                                    [svgIcon]="
                                        'heroicons_solid:arrow-down-circle'
                                    "
                                ></mat-icon>
                                <div
                                    class="ml-1 text-md font-medium text-red-500"
                                >
                                    13.1%
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-3 flex h-80 flex-auto flex-col">
                <apx-chart
                    class="h-full w-full flex-auto"
                    [chart]="chartVisitorsVsPageViews.chart"
                    [colors]="chartVisitorsVsPageViews.colors"
                    [dataLabels]="chartVisitorsVsPageViews.dataLabels"
                    [grid]="chartVisitorsVsPageViews.grid"
                    [legend]="chartVisitorsVsPageViews.legend"
                    [series]="chartVisitorsVsPageViews.series"
                    [stroke]="chartVisitorsVsPageViews.stroke"
                    [tooltip]="chartVisitorsVsPageViews.tooltip"
                    [xaxis]="chartVisitorsVsPageViews.xaxis"
                    [yaxis]="chartVisitorsVsPageViews.yaxis"
                ></apx-chart>
            </div>
        </div>
         -->

    </div>
    }
</div>
